<template>
	<el-dialog title="导出" :visible.sync="dialogVisible" width="578px" :before-close="handleClose">
		<div class="deriving" v-if="isActive==0">
			<div>
				文件导出中...
			</div>
			<div>
				正在导出 申请名录...
			</div>
			<el-progress :text-inside="true" :stroke-width="32" :percentage="num" stroke-linecap="round" status="success"
				color></el-progress>
		</div>
		<div class="failure" v-if="isActive==1">
			<img src="@/assets/images/组10972@3x.png" alt="">
			<div class="text">
				<div>导出成功</div>
				<div>共计数据：265条</div>
			</div>
		</div>
		<div class="failure" v-if="isActive==2">
			<img src="@/assets/images/12227@3x.png" alt="">
			<div class="text">
				<div>导出失败</div>
				<div>网络中断，请检查网络是否连接正常</div>
			</div>
		</div>
		<span slot="footer">
			<el-button v-if="isActive==2" type="primary" @click="handleClose()" class="btn btn-plus">
				确 定
			</el-button>
			<el-button v-if="isActive==1" type="primary" @click="handleClose()" class="btn btn-plus">
				打开文件夹
			</el-button>
			<el-button v-if="isActive==1" @click="handleClose()" class="btn ">
				完 成
			</el-button>
			<el-button v-if="isActive==0" type="danger" @click="pause" class="btn btn-bel">
				停 止
			</el-button>
		</span>
	</el-dialog>
</template>
<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				isActive: 0,
				num:0,
				timer:null
			}
		},
		methods: {
			open() {
				this.dialogVisible = true
				this.isActive= 0
				this.num=0
				this.timer=setInterval(()=>{
					this.num+=10
					if(this.num==100){
						clearInterval(this.timer)
						this.isActive=1
					}
				},1000)
			},
			pause(){
				this.isActive=2
				clearInterval(this.timer)
			},
			handleClose() {
				clearInterval(this.timer)
				this.dialogVisible = false
			},
		},
	}
</script>
<style lang="scss" scoped>
	/deep/ .el-dialog__header {
		padding: 16px 20px 10px;
		background-color: #f4f6fc;
		height: 50px;
		box-sizing: border-box;
	}

	/deep/ .el-dialog__title {
		font-family: Microsoft YaHei;
		font-size: 15px;
		font-weight: bold;
		font-stretch: normal;
		line-height: 20px;
		letter-spacing: 0px;
		color: #24262b;
	}

	/deep/ .el-form-item__label {
		font-family: Microsoft YaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 19px;
		letter-spacing: 0px;
		color: #545454;
	}

	/deep/ .el-form-item {
		margin-bottom: 17px;
	}

	/deep/ .el-dialog__footer {
		padding-top: 0;
	}

	/deep/ .el-progress {
		margin: 26px 0;
	}

	/deep/ .el-progress-bar__outer {
		border-radius: 5px;
		background-color: #C2EBCF !important;
	}

	/deep/ .el-progress-bar__inner {
		border-radius: 0;
	}

	/deep/.el-progress.is-success .el-progress-bar__inner {
		background: linear-gradient(to right, #1CB943, #90ED5A, #1CB943);
	}

	.btn {
		height: 40px;
	}

	.btn-plus {
		background-color: #0147eb;
	}

	.btn-bel {
		background-color: #F04444;
	}

	.deriving {
		div:nth-child(1) {
			font-size: 24px;
			line-height: 25px;
			color: #1d2329;
		}

		div:nth-child(2) {
			font-size: 14px;
			line-height: 25px;
			color: #1d2329;
		}
	}

	.failure {
		display: flex;
		align-items: center;

		img {
			width: 88px;
			height: 88px;
			margin-right: 30px;
		}

		.text {
			div:nth-child(1) {
				font-size: 24px;
				line-height: 25px;
				color: #373738;
			}

			div:nth-child(2) {
				font-size: 14px;
				line-height: 40px;
				color: #373738;
			}
		}

	}
</style>
